import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as hrDashboardAPI from '../../api/HRAPI/hrDashboardAPI';

export const fetchHRDashboardSummary = createAsyncThunk(
    'hrDashboard/fetchHRDashboardSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await hrDashboardAPI.getHRDashboardSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch HR Dashboard Summary');
        }
    }
);

const initialState = {
    summary: null,
    loading: false,
    error: null,
};

const hrDashboardSlice = createSlice({
    name: 'hrDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHRDashboardSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHRDashboardSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.summary = action.payload;
            })
            .addCase(fetchHRDashboardSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectHRDashboardSummary = (state) => state.hrDashboard.summary;
export const selectHRDashboardLoading = (state) => state.hrDashboard.loading;

export default hrDashboardSlice.reducer;
